import React from 'react';

import http from 'Demora/http';

import Rate from 'rc-rate';

import 'rc-rate/assets/index.css';

class AddEditWebsiteReviews extends React.Component {
	constructor(props) {
		super();

		const state = {
			domain: null,
			name: '',
			rate: null,
			review: '',
			saving: false,
			title: '',
			url: '',
		};

		const review = props.review;

		if (review) {
			state.domain = review.domain;
			state.name = review.name;
			state.rate = review.rate;
			state.review = review.review;
			state.title = review.title;
			state.url = review.url;
		}

		this.state = state;
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	setValue = (k, v) => {
		const v1 = {};
		v1[k] = v;

		this.setState(v1);
	};

	next1 = () => {
		const state = this.state;

		const url = this.state.url;

		if (this.isValidURL(url) && state.name) {
			this.setValue('domain', url.split('/')[2].split('?')[0]);
		}
	};

	changeURL = () => {
		this.setState({
			domain: null,
			rate: null,
			review: '',
			title: '',
		});
	};

	isValidURL = (url) => {
		try {
			new URL(url);
			return true;
		} catch (_) {
			return false;
		}
	};

	save = () => {
		this.setState({
			saving: true,
		});

		const props = this.props;

		if (props.review) {
			return http
				.put('/data/web_reviews/' + props.review.id, this.state)
				.then(this.afterSave);
		}

		return http.post('/data/web_reviews', this.state).then(this.afterSave);
	};

	afterSave = (data) => {
		if (this.unmounted) {
			return;
		}

		if (!data.rufP) {
			this.setState({
				saving: false,
			});

			return;
		}
		this.props.getData();
	};

	render() {
		const state = this.state;

		return (
			<div className='container'>
				<div className='row'>
					<div className='col-12 mb-4'>
						<h5>Enter the name or the website</h5>
						<input
							type='text'
							className='form-control'
							id='inlineFormInputGroupUsername'
							placeholder='Name'
							value={state.name}
							onChange={(e) => this.setValue('name', e.target.value)}
							disabled={state.domain !== null}
						/>
					</div>
					<div className='col-12 mb-4'>
						<h5>Enter the URL or the website</h5>
						<input
							type='text'
							className='form-control'
							id='inlineFormInputGroupUsername'
							placeholder='URL'
							value={state.url}
							onChange={(e) => this.setValue('url', e.target.value)}
							disabled={state.domain !== null}
						/>
					</div>
					<div className='col-12 text-right'>
						{state.domain === null ? (
							<button className='btn btn-primary mb-4' onClick={this.next1}>
								Next
							</button>
						) : (
							<button className='btn btn-warning mb-4' onClick={this.changeURL}>
								Change URL
							</button>
						)}
					</div>
				</div>
				{!!state.domain && !!state.name && (
					<div className='row mb-4'>
						<div className='col-12'>
							<h5>The Website</h5>
							{state.domain}
						</div>
					</div>
				)}
				{state.domain !== null && (
					<div className='row mb-4'>
						<div className='col-12'>
							<h5>Rate your Experience</h5>
							<Rate
								onChange={(e) => this.setValue('rate', e)}
								value={state.rate}
								style={{ fontSize: '18px' }}
							/>
						</div>
					</div>
				)}
				{state.rate !== null && (
					<div className='row mb-4'>
						<div className='col-12'>
							<h5>Write Your Review</h5>
							<textarea
								onChange={(e) => this.setValue('review', e.target.value)}
								value={state.review}
								className='form-control'
								rows='6'
							></textarea>
						</div>
					</div>
				)}
				{state.rate !== null && (
					<div className='row mb-4'>
						<div className='col-12 mb-4'>
							<h5>Give your review a title</h5>
							<input
								type='text'
								className='form-control'
								placeholder='Title'
								value={state.title}
								onChange={(e) => this.setValue('title', e.target.value)}
							/>
						</div>{' '}
						<div className='col-12 text-right'>
							<button
								className='btn btn-primary'
								onClick={this.save}
								disabled={!state.title || !state.review || state.saving}
							>
								Save
							</button>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default AddEditWebsiteReviews;
